/**
 * Determines if a member is an admin of an enterprise
 */
export const isEnterpriseAdmin = (
  member: { idEnterprisesAdmin: Array<string> },
  idEnterprise: string,
): boolean => {
  return member.idEnterprisesAdmin.includes(idEnterprise);
};
